import React, { useEffect } from 'react';
import { Box } from '@mui/material';

interface WorkListDrawerProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

const DRAWER_WIDTH = 340;

const WorkListDrawer: React.FC<WorkListDrawerProps> = ({ open, onClose, children }) => {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && open) onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [open, onClose]);

    return (
        <>
            {/* Backdrop */}
            <Box
                onClick={onClose}
                sx={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: 1200,
                    backgroundColor: 'rgba(0,0,0,0.4)',
                    opacity: open ? 1 : 0,
                    pointerEvents: open ? 'all' : 'none',
                    transition: 'opacity 0.3s ease',
                }}
            />

            {/* Drawer */}
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    height: '100vh',
                    width: DRAWER_WIDTH,
                    zIndex: 1201,
                    transform: open ? 'translateX(0)' : `translateX(${DRAWER_WIDTH}px)`,
                    transition: 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    boxShadow: '-8px 0 40px rgba(0,0,0,0.3)',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </Box>
        </>
    );
};

export default WorkListDrawer;
